import { DesktopTable } from './desktop/DesktopTable';
import { MobileTable } from './mobile/MobileTable';

export const Table = ({ screen, ...props }) => {
  const isMobileScreen = screen === 'mobile';

  return isMobileScreen ? <MobileTable {...props} /> : <DesktopTable {...props} />;
};
